import React from 'react';
import './PaymentMethod.css';
import fallbackIcon from '../../assets/images/b1.png';

export default function PaymentMethodd({ gateways = [], selectedGateway, onSelect, onPay, busy, payable, ready }) {
  return (
    <div className="payment-methods">
      <h2 className="payment-method__title">Select Payment Method</h2>
      <div className="payment-method__list">
        {gateways.map((gateway) => {
          const selected = selectedGateway?.payment_gateway_id === gateway.payment_gateway_id;
          const isManual = gateway.slug === 'bank-transfer' || gateway.slug === 'upi-transfer';
          return (
            <button type="button" key={gateway.payment_gateway_id || gateway.slug} className={`payment-method__item ${selected ? 'payment-method__item--selected' : ''}`} onClick={() => onSelect(gateway)} disabled={!ready || busy} aria-pressed={selected}>
              <div className="payment-method__icon online-icon"><img src={gateway.image_url || gateway.gateway_img_url || fallbackIcon} alt="" onError={(event) => { event.currentTarget.onerror = null; event.currentTarget.src = fallbackIcon; }} /></div>
              <div className="payment-method__content"><h3>{gateway.gateway || (isManual ? gateway.slug.replace('-', ' ') : gateway.slug || 'Payment gateway')}</h3><p>{isManual ? 'Transfer using the supplied payment details' : (gateway.description || 'Select this payment method')}</p></div>
              <div className={`payment-method__checkbox ${selected ? 'payment-method__checkbox--selected' : ''}`}>{selected ? <i className="bi bi-check2" /> : null}</div>
            </button>
          );
        })}
      </div>
      {!gateways.length ? <p role="alert">Payment methods are currently unavailable.</p> : null}
      <button type="button" className="coinn-pack-buy-btn" style={{ marginTop: 20, width: '100%' }} onClick={onPay} disabled={!ready || !selectedGateway || busy || !Number.isFinite(Number(payable)) || Number(payable) <= 0}>{busy ? 'Please wait...' : `Pay ₹ ${Number(payable || 0).toFixed(2)}`}</button>
    </div>
  );
}
